var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluginsStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76.24 63.98",
    className: "img large",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{clip-path:url(#clippath);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.5,15.29l-8.03-12.82c-.72-1.16-1.99-1.86-3.35-1.86H13.12c-1.36,0-2.63,.7-3.36,1.86L1.73,15.29c-4.15,6.62-.47,15.83,7.28,16.88,.56,.07,1.13,.11,1.7,.11,3.49,0,6.81-1.49,9.13-4.1,4.49,5.04,12.22,5.49,17.27,1,.35-.31,.69-.65,1-1,4.49,5.04,12.22,5.49,17.27,1,.35-.31,.69-.65,1-1,2.32,2.6,5.64,4.1,9.13,4.1,.57,0,1.14-.04,1.7-.11,7.77-1.04,11.46-10.25,7.3-16.88h0Zm-8.97,18.74c-1.23-.01-2.46-.17-3.65-.47v15.07H14.35v-15.07c-1.2,.29-2.42,.45-3.65,.47-.75,0-1.49-.05-2.23-.15-.69-.1-1.36-.25-2.03-.45v26.59c0,2.18,1.77,3.96,3.95,3.96,0,0,0,0,.01,0h55.45c2.18,0,3.96-1.77,3.96-3.95,0,0,0,0,0-.01v-26.58c-.66,.2-1.34,.35-2.03,.45-.75,.1-1.5,.15-2.25,.15h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -289.74,
    y1: 459.23,
    x2: -288.99,
    y2: 457.48,
    gradientTransform: "translate(39117.96 -24663.77) rotate(-90) scale(85.36 -85.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -283.44,
    y1: 458.5,
    x2: -282.44,
    y2: 458.5,
    gradientTransform: "translate(34722.19 56329.7) scale(122.65 -122.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a7aa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7198"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3078",
    className: "cls-2",
    x: -4.56,
    y: -26.34,
    width: 85.36,
    height: 85.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "gradient_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3292",
    className: "cls-4",
    x: -41.86,
    y: 33.03,
    width: 122.65,
    height: 122.65
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluginsStore);
export default __webpack_public_path__ + "static/media/plugins-store.79ee52df1704e5b75120f4d79dff826a.svg";
export { ForwardRef as ReactComponent };